import { useCallback, useEffect, useState } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import Plotly from "plotly.js-dist-min";

const Plot = createPlotlyComponent(Plotly);

const GaugePlot = ({ title, value }) => {
  const [chartData, setChartData] = useState([]);
  const [chartLayout, setChartLayout] = useState();
  const [showPlot, setShowPlot] = useState(false);

  const createChartLayout = () => {
    const plotLayout = {
      width: 600,
      height: 380,
      paper_bgcolor: "rgba(0,0,0,0)",
      plot_bgcolor: "rgba(0,0,0,0)",
      font: { color: "white" },
    };
    setChartLayout(plotLayout);
  };

  const createChartData = useCallback(() => {
    const plotData = [
      {
        value,
        title: {
          text: title,
          font: {
            size: 24,
          },
        },
        type: "indicator",
        mode: "gauge+number",
        gauge: {
          axis: {
            range: [0, 100],
          },
          bar: {
            color: "transparent",
          },
          threshold: {
            line: {
              color:
                value >= 0 && value <= 33
                  ? "red"
                  : value > 33 && value <= 66
                  ? "orange"
                  : "#3b82f6",
              width: 4,
            },
            thickness: 0.75,
            value: value,
          },
        },
        number: {
          font: {
            color:
              value >= 0 && value <= 33
                ? "red"
                : value > 33 && value <= 66
                ? "orange"
                : "#3b82f6",
            size: 36,
          },
        },
      },
    ];
    setChartData(plotData);
  }, [value, title, setChartData]);

  useEffect(() => {
    if (value === undefined || value === null) {
      setShowPlot(false);
      return;
    }

    createChartData();
    createChartLayout();
    setShowPlot(true);
  }, [value, createChartData]);

  return (
    <div className="flex align-center justify-center">
      {chartLayout &&
        chartData !== undefined &&
        chartData !== null &&
        showPlot && <Plot data={chartData} layout={chartLayout} />}
    </div>
  );
};

export default GaugePlot;
